import { render, staticRenderFns } from "./Base64Uploader.vue?vue&type=template&id=23f8604e"
import script from "./Base64Uploader.vue?vue&type=script&lang=ts"
export * from "./Base64Uploader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports